import { BaseModel, HasId } from "./base";
import { DisplayName } from "../components/select/base-select-with-id.component";

export class PaymentReceiver extends BaseModel implements DisplayName, HasId {

    get id(): string {
        return this.code;
    }

    get displayName(): string {
        return this.code;
    }

    public code: string;

    constructor(json?: any) {
        super(json)
    }

    public initialize(json: any): void {
        if (typeof json === 'string') {
            json = {
                code: json
            };
        }
        super.initialize(json);
    }
}